import React from "react";
import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import PropTypes from "prop-types";

export default class FFLTextField extends Framework.Elements.TextField{
	static propTypes = {
		...Framework.Elements.TextField.propTypes,
		update: PropTypes.func,
		dealer: PropTypes.any.isRequired
	}

	constructor(props) {
		super(props);
		this.state.ffl_valid_status = 'none';
		this.state.ffl_validation_message = null;
		this.state.ez_check_url = '';
	}

	componentDidMount() {
			this.validateFFL();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.dealer !== this.props.dealer) {
			this.setState({
				ffl_valid_status: 'none',
				ffl_validation_message: null,
				ez_check_url: ''
			}, this.validateFFL);
		}
	}

	handleFFLTextFieldPropertyUpdate = (property, value) => {
		if( this.props.update ) {
			this.props.update(property, value);
		}
		this.validateFFL();
	}

	validateFFL = () => {
		if( !this.props.dealer ) {
			return;
		}
		let requesting = this.props.dealer.pkey ? 'GET_VALIDATE' : 'GET_VALIDATE_NEW';
		let fflModel = new API.BuildClass(Types.Dealers._name, requesting);
		if( this.props.dealer.pkey ) {
			fflModel.object.pkey = this.props.dealer.pkey;
			fflModel.object.binary_id = this.props.dealer.binary_id;
		} else {
			if( !this.props.dealer.ffl || this.props.dealer.ffl.length !== 20 ) {
				return;
			}
			fflModel.object.ffl = this.props.dealer.ffl;
			fflModel.object.name_company = this.props.dealer.name_company;
			fflModel.object.zip = this.props.dealer.zip;
			fflModel.object.street_1 = this.props.dealer.street_1;
			fflModel.object.street_2 = this.props.dealer.street_2;
			fflModel.object.city = this.props.dealer.city;
			fflModel.object.state = this.props.dealer.state;
		}
		fflModel.submit(null, requesting).then( resp => {
			this.setState({
				ffl_valid_status: resp.color,
				ffl_validation_message: resp.message,
				ez_check_url: resp.link,
			});
			if (resp.date && typeof this.props.ffl_expiration ==='function') {
				this.props.ffl_expiration(resp.date)
			}
			if (typeof this.props.billing_address_lines === 'function') {
				this.props.billing_address_lines(Array.isArray(resp.billing_address_lines) ? resp.billing_address_lines : null);
			}
		}).catch(e => {
			this.setState({
				ffl_valid_status: 'danger',
				ffl_validation_message: e && e.responseJSON ? e.responseJSON.response : 'Unable to verify FFL.',
				ez_check_url: '',
			} );
		});
	}

	render() {
		return(
			<div>
				<Framework.Elements.TextField
					className={`ffl-valid-${this.state.ffl_valid_status || 'none'}`}
					label={this.props.label}
					property={this.props.property}
					value={this.props.value}
					error={this.props.error}
					update={this.handleFFLTextFieldPropertyUpdate}
					InputProps={{
						inputComponent: Framework.Masks.FFL,
					}}
				/>
				<div className={`ffl-valid-msg ${this.state.ffl_validation_message ? 'alert' : 'd-none'} alert-${this.state.ffl_valid_status}`} style={{marginTop: '1rem', marginBottom: '1.5rem', padding: '6px 10px'}}>
					{this.state.ffl_validation_message}<br />
					{this.state.ez_check_url && <a href={this.state.ez_check_url} target={'_blank'}>Validate on EZ Check</a>}
				</div>
			</div>

		)
	}
}

